import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DollarSign, TrendingUp } from "lucide-react";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";
import { PageHeader, Loading, StatCard, DataTable, SandboxTag } from "../components/common";

export default function Value() {
  const { t } = useI18n();
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/usecases", { params: { limit: 1000 } }).then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loading />;

  const fmt = (n) => `$${(n / 1e6).toFixed(2)}M`;
  const cost = rows.reduce((a, r) => a + (r.estimated_cost || 0), 0);
  const expected = rows.reduce((a, r) => a + (r.expected_value || 0), 0);
  const actual = rows.reduce((a, r) => a + (r.actual_value || 0), 0);
  const roi = Math.round((actual / (cost || 1)) * 100);

  const cols = [
    { key: "id", label: "ID", render: (r) => <span className="font-mono text-xs font-bold text-[var(--qatar)]">{r.id}</span> },
    { key: "name_en", label: "Use Case", render: (r) => <span className="font-medium">{r.name_en}</span> },
    { key: "estimated_cost", label: "Cost", render: (r) => `$${(r.estimated_cost / 1e3).toFixed(0)}K` },
    { key: "expected_value", label: "Expected", render: (r) => `$${(r.expected_value / 1e3).toFixed(0)}K` },
    { key: "actual_value", label: "Actual", render: (r) => `$${(r.actual_value / 1e3).toFixed(0)}K` },
    { key: "roi", label: "ROI", render: (r) => `${r.roi}%` },
    { key: "value_realisation", label: "Realisation", render: (r) => `${r.value_realisation}%` },
  ];

  return (
    <div>
      <PageHeader title={t("nav.value")} subtitle="AI value realisation — all figures are synthetic sandbox estimates" summary="AI value realisation. Synthetic estimates of cost, expected value, actual value and return on investment across the portfolio.">
        <SandboxTag text="SYNTHETIC SANDBOX ESTIMATE" />
      </PageHeader>

      <div className="mb-6 grid grid-cols-2 gap-4 md:grid-cols-4">
        <StatCard testid="val-cost" label="Total AI Cost" value={fmt(cost)} icon={DollarSign} sub="SYNTHETIC" />
        <StatCard testid="val-expected" label="Expected Value" value={fmt(expected)} icon={TrendingUp} sub="SYNTHETIC" />
        <StatCard testid="val-actual" label="Realised Value" value={fmt(actual)} icon={TrendingUp} accent="bg-emerald-50 text-emerald-600" sub="SYNTHETIC" />
        <StatCard testid="val-roi" label="Portfolio ROI" value={`${roi}%`} icon={TrendingUp} accent="bg-emerald-50 text-emerald-600" sub="SYNTHETIC" />
      </div>

      <DataTable testid="value-table" columns={cols} rows={rows} onRowClick={(r) => nav(`/usecases/${r.id}`)} pageSize={20} />
    </div>
  );
}
